/** @module csi/monitor/PollingNodeMonitor */
define([
    "dojo/_base/declare",
    "dojo/_base/lang",
    "./NodeMonitor"
], function(declare,lang,NodeMonitor) {

    var Monitor = declare(NodeMonitor, {

        interval: 5000,

        _handleTimer: null,

        setRefreshInterval: function(/*Number*/milliseconds) {
            this.interval = milliseconds;
            //console.log("setRefreshInterval=", milliseconds);
        },

        addEventListener: function(type, callback) {
            this.inherited(arguments);

            // schedule a node refresh if it was not scheduled before
            if (this._handleTimer == null) {
                this._scheduleNodeRefresh();
            }
        },

        _onRefreshNode: function(/*Response*/response) {
            this._cancelNodeRefresh();

            this.inherited(arguments);

            this._scheduleNodeRefresh();
        },

        /**
         * Cancel a node refresh if any
         */
        _cancelNodeRefresh: function() {
            if (this._handleTimer != null) {
                //console.log("_cancelNodeRefresh for", this.url);
                clearTimeout(this._handleTimer);
                this._handleTimer = null;
            }
        },

        /**
         * Schedule a node refresh if there are listeners
         */
        _scheduleNodeRefresh: function() {
            if (this.hasListeners()) {
                //console.log("_scheduleNodeRefresh for", this.url);
                this._handleTimer = setTimeout(lang.hitch(this, this.refreshNode, false), this.interval);
            }
        }
    });

    /**
     * PollingNodeMonitor factory function
     */
    Monitor.createMonitorForUrl = function(/*String*/url) {
        var monitor = new Monitor(url);
        //console.log("Created PollingNodeMonitor for", url);
        return monitor;
    };

    return Monitor;
});